// extracted by mini-css-extract-plugin
module.exports = {"progressBar":"ProgressIndicator_progressBar__hAzQh","shimmer":"ProgressIndicator_shimmer__2bAfN","stepCount":"ProgressIndicator_stepCount__16Kwi"};